/* eslint-disable */
export default {
  _Bckg1Large: 'Bckg1Large',
  _Bckg2Large: 'Bckg2Large',
  _TitleScreenGradient: 'TitleScreenGradient',
  _ItemGlow: 'ItemGlow',
  _Spear_Missing: 'Spear_Missing',
  _Sword_Large: 'Sword_Large',
  _LogoRingBlue: 'LogoRingBlue',
  _Round3UI: 'Round3UI',
  _FuelGaugeEmpty: 'FuelGaugeEmpty',
  _Spear: 'Spear',
  _UIGearInside: 'UIGearInside',
  _FuelGaugeFill: 'FuelGaugeFill',
  _LogoGlowBlue: 'LogoGlowBlue',
  _Column_Missing: 'Column_Missing',
  _MannequinHeadRight: 'MannequinHeadRight',
  _Column: 'Column',
  _MannequinHeadLeft: 'MannequinHeadLeft',
  _JadeDog_Missing: 'JadeDog_Missing',
  _Crown: 'Crown',
  _AfricanMask: 'AfricanMask',
  _MenuBtn: 'MenuBtn',
  _UILightLit: 'UILightLit',
  _Chalice: 'Chalice',
  _MuteBtn: 'MuteBtn',
  _UnmuteBtn: 'UnmuteBtn',
  _CloseBtn: 'CloseBtn',
  _FuelFillTopLight: 'FuelFillTopLight',
  _screwBase: 'screwBase',
  _screwHole: 'screwHole',
  _Spear_Large: 'Spear_Large',
  _AlarmOverlay: 'AlarmOverlay',
  _UINavBar: 'UINavBar',
  _Column_Large: 'Column_Large',
  _Headdress_Large: 'Headdress_Large',
  _JadeDog_Large: 'JadeDog_Large',
  _Rug_Missing: 'Rug_Missing',
  _FabergeEgg_Large: 'FabergeEgg_Large',
  _Rug: 'Rug',
  _Painting_Large: 'Painting_Large',
  _UIGearOutside: 'UIGearOutside',
  _Dante_Large: 'Dante_Large',
  _Ankh_Large: 'Ankh_Large',
  _Crown_Large: 'Crown_Large',
  _WordPortalOrangeVortex: 'WordPortalOrangeVortex',
  _Chalice_Large: 'Chalice_Large',
  _AfricanMask_Large: 'AfricanMask_Large',
  _PlayAgainSpeechBubble: 'PlayAgainSpeechBubble',
  _WordPortalOrangeFrame: 'WordPortalOrangeFrame',
  _FuelGaugeOverlay: 'FuelGaugeOverlay',
  _GetItemGlow1: 'GetItemGlow1',
  _elecOrange: 'elecOrange',
  _Round2WordTileArea: 'Round2WordTileArea',
  _Katana_Missing: 'Katana_Missing',
  _Sword_Missing: 'Sword_Missing',
  _elecBlue: 'elecBlue',
  _Sword: 'Sword',
  _Crown_Missing: 'Crown_Missing',
  _Vase: 'Vase',
  _GetItemPulse1: 'GetItemPulse1',
  _ArtifactProgressUI: 'ArtifactProgressUI',
  _GetItemPulse4: 'GetItemPulse4',
  _Painting_Missing: 'Painting_Missing',
  _Headdress_Missing: 'Headdress_Missing',
  _Painting: 'Painting',
  _MayanMask_Missing: 'MayanMask_Missing',
  _Headdress: 'Headdress',
  _WordTileBlank: 'WordTileBlank',
  _glass: 'glass',
  _Dante: 'Dante',
  _MuseumBtn: 'MuseumBtn',
  _AlarmUnlit: 'AlarmUnlit',
  _LogoGlowOrange: 'LogoGlowOrange',
  _Round3WordTile: 'Round3WordTile',
  _GetItemPulse2: 'GetItemPulse2',
  _NextBtn: 'NextBtn',
  _FabergeEgg: 'FabergeEgg',
  _PlayBtn: 'PlayBtn',
  _TricornHat_Missing: 'TricornHat_Missing',
  _MayanMask: 'MayanMask',
  _AlarmLit: 'AlarmLit',
  _Lamp_Missing: 'Lamp_Missing',
  _AfricanMask_Missing: 'AfricanMask_Missing',
  _ExitBtn: 'ExitBtn',
  _MeterNeedle: 'MeterNeedle',
  _ResumeBtn: 'ResumeBtn',
  _Lamp: 'Lamp',
  _Ankh_Missing: 'Ankh_Missing',
  _Telephone_Missing: 'Telephone_Missing',
  _GlassHighlights: 'GlassHighlights',
  _LogoOrb3: 'LogoOrb3',
  _LogoPole4: 'LogoPole4',
  _UILightUnlit: 'UILightUnlit',
  _pipe: 'pipe',
  _Chalice_Missing: 'Chalice_Missing',
  _LogoPole2: 'LogoPole2',
  _LogoPole3: 'LogoPole3',
  _JadeDog: 'JadeDog',
  _LogoOrb1: 'LogoOrb1',
  _CheckBtn: 'CheckBtn',
  _PlayAgainBtn: 'PlayAgainBtn',
  _GetItemParticle1: 'GetItemParticle1',
  _WallNail: 'WallNail',
  _GetItemParticle2: 'GetItemParticle2',
  _Katana_Large: 'Katana_Large',
  _Rug_Large: 'Rug_Large',
  _LogoOverlay: 'LogoOverlay',
  _keyboardBckg: 'keyboardBckg',
  _machine: 'machine',
  _Telephone_Large: 'Telephone_Large',
  _RaptorSkull_Large: 'RaptorSkull_Large',
  _InstruxPopup1: 'InstruxPopup1',
  _TricornHat_Large: 'TricornHat_Large',
  _Lamp_Large: 'Lamp_Large',
  _LogoRingOrange: 'LogoRingOrange',
  _WordPortalBlue: 'WordPortalBlue',
  _Vase_Large: 'Vase_Large',
  _MayanMask_Large: 'MayanMask_Large',
  _LogoGear: 'LogoGear',
  _GetItemGlow2: 'GetItemGlow2',
  _PausePopup: 'PausePopup',
  _MuseumPlaque: 'MuseumPlaque',
  _AlarmLight: 'AlarmLight',
  _Katana: 'Katana',
  _Vase_Missing: 'Vase_Missing',
  _RaptorSkull_Missing: 'RaptorSkull_Missing',
  _Round2WordTile: 'Round2WordTile',
  _Dante_Missing: 'Dante_Missing',
  _TricornHat: 'TricornHat',
  _Ankh: 'Ankh',
  _TextEntryField: 'TextEntryField',
  _keyBtn: 'keyBtn',
  _RaptorSkull: 'RaptorSkull',
  _GetItemPulse3: 'GetItemPulse3',
  _delBtn: 'delBtn',
  _UIGearHand: 'UIGearHand',
  _Chain: 'Chain',
  _Telephone: 'Telephone',
  _FabergeEgg_Missing: 'FabergeEgg_Missing',
  _SmokeParticle: 'SmokeParticle',
  _LogoOrb2: 'LogoOrb2',
  _LogoOrb4: 'LogoOrb4',
  _FuelFillTopDark: 'FuelFillTopDark',
  _GetItemParticle3: 'GetItemParticle3',
  _LogoPole1: 'LogoPole1',
}